import { getActiveTenantId, setActiveTenantId } from './tenantHeader.ts';

/**
 * A global admin's non-member "context" workspace lives only while its URL is open. Once the
 * route leaves `/:slug/...` (personal pages, the picker, another workspace) it must go: otherwise
 * its X-Tenant-Id, pages and socket rooms keep riding on unrelated requests. Pure (node --test).
 */
export function leftContextTenant(pathname: string, contextSlug: string | null | undefined): boolean {
  if (!contextSlug) return false;
  const first = pathname.split('/').filter(Boolean)[0];
  if (!first) return true;
  let segment = first;
  try {
    segment = decodeURIComponent(first);
  } catch {
    // malformed escape — compare raw
  }
  return segment !== contextSlug;
}

/**
 * Stop sending the context workspace's X-Tenant-Id. Only if it is still the active one — by the
 * time this runs the next route may already have made an own workspace active.
 */
export function clearContextHeader(contextTenantId: string): void {
  if (getActiveTenantId() === contextTenantId) setActiveTenantId(null);
}
